import {
  Avatar,
  Box,
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import Style from "../styles/appbar.module.scss";
import MenuIcon from "@mui/icons-material/Menu";
import { ThemeContext } from "../context/ThemeProvider";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Logout } from "@mui/icons-material";
import Person2Icon from "@mui/icons-material/Person2";
import { useSelector } from "react-redux";
import Featured from "../assets/img/Featured.png";
import backgroundImage from "../assets/img/Bg PatternH.png";
import forwardArrow from "../assets/img/Arrow.svg";

import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import Arrow from '../assets/img/Arrow.png'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import useScreenWidth from "../hooks/useScreenWidth";
import { TiThMenu } from "react-icons/ti";


export default function AppbarUI() {
  const navigate = useNavigate();
  const { drawerSilde, setDrawerSilde } = useContext(ThemeContext);
 const screenWidth = useScreenWidth()
  const [menuVisible, setMenuVisible] = useState(false);
  const [profileAnchor, setProfileAnchor] = useState();

  const myProfile = useSelector((state) => state.myProfile);
  const { message, data, status, loading } = myProfile;

  // function
  const handleSidebarToggle = () => {
    setDrawerSilde(!drawerSilde);
  };

  const logOutFunc = () => {
    localStorage.removeItem("auth_token");
    window.location.reload()
    navigate("/login");
  };

  const styles = {
    boxContainer: {
      // backgroundImage: `url(${backgroundImage})`,
      // backgroundSize: 'cover',
      // backgroundPosition: 'center',
      pl: 2,
      display: "flex",
      alignItems: "center",
      width: "100%",
      
      // zIndex:'10'
      // border:'2px solid black'
      // Add any additional styling properties as needed
    },
  };
  useEffect(()=>{
      window.scrollTo(0,0)
  },[])

  useEffect(() => {
    if (screenWidth > 700) {
      setDrawerSilde(true)
    } else{
      setDrawerSilde(false)
    }
  }, [screenWidth])

  return (
    <Stack
      direction={"row"}
      className={drawerSilde ? Style?.appbar_open : Style?.appbar_close}
      style={{position:'fixed',top:0}}
    >    

      <Box
        sx={
          styles.boxContainer
        }
      >
        {/* {drawerSilde ? (
          <IconButton onClick={handleSidebarToggle}  sx={{marginTop:'60%',position:'absolute',left:'-35px',zIndex:'2' }}>
            {" "}
            
            <ArrowBackIosNewIcon/>
          </IconButton>
        ) : (
          <IconButton onClick={handleSidebarToggle} 
          
          sx={{marginTop:'50%',position:'absolute',left:'-35px',zIndex:'2' ,left:'0px'}}
          >

            <ArrowForwardIosIcon/>
           

          </IconButton>
        )} */}
        <Typography
        variant="h6" fontWeight={600} sx={{ color: "#000", flexGrow: 1 }}>
          Publisher Panel
        </Typography>
      </Box>

      <Stack
        sx={{ pr: 2 }}
        direction={"row"}
        alignItems={"center"}
      >
     { screenWidth > 700 ?  <IconButton
          onClick={(event) => {
            setMenuVisible(true);
            setProfileAnchor(event.currentTarget);
          }}
        >
          <Stack direction={"row"} spacing={1} alignItems={"center"}>
            <Avatar sx={{background: "linear-gradient(177.64deg, #FFB100 10.65%, #FE299F 275.27%)" }} >{data?.name?.charAt(0)?.toUpperCase()}</Avatar>
          </Stack>
        </IconButton >

        : <TiThMenu size={25} onClick={handleSidebarToggle} />}
      </Stack> :       


      <Menu
        anchorEl={profileAnchor}
        open={menuVisible}
        
        onClose={() => setMenuVisible(false)}
      >
        <Box sx={{ p: 2, width: 200, }}>
          <Typography sx={{ mb: 1 }} variant="subtitle2">
            👋 Hey,<strong>{" " +data.name}</strong>
          </Typography>
        </Box>
        <Divider />
        <MenuItem onClick={() => navigate("/profile")}>
          <ListItemIcon>
            <Person2Icon color="#000" />
          </ListItemIcon>
          Profile
        </MenuItem>
        <Divider />
        <MenuItem onClick={logOutFunc}>
          <ListItemIcon>
            <Logout color="primary" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </Stack>
  );
}
